// import http from '../httpService';
// import axios from 'axios';
// import {BASE_URL, token} from '../../utils/const';
// // import {Toast} from '../../../utils/sweetAlert';
// import {t} from 'react-switch-lang';
// import Swal from 'sweetalert2';

// const main = 'financial-performances';

// export function getAllFinancialPerformances() {
//   // return http.get(`/financial-performances`);
//   return axios({
//     method: 'GET',
//     url: `${BASE_URL}/${main}`,
//     headers: {
//       Authorization: 'Bearer ' + token,
//       Accept: '*/*',
//     },
//   });
// }
// export function addAllFinancialPerformances() {
//   return http.post(`/financial-performances`);
// }
// export function deleteAllFinancialPerformances() {
//   return http.delete(`/financial-performances/{id}`);
// }
// export function editAllFinancialPerformances() {
//   return http.put(`/financial-performances`);
// }

import http from '../httpService';

export function getAllFinancialPerformances() {
  return http.get(`/financial-performances`);
}

export function updateFinancialPerformance(payload) {
  return http.put('/financial-performances', payload);
}

export function createFinancialPerformance(payload) {
  return http.post('/financial-performances', payload);
}

export function deleteFinancialPerformance(id) {
  return http.delete(`/financial-performances/${id}`);
}